import {pick} from 'lodash';
import shallowequal from 'shallowequal';

export const hasShallowDiff = (previous, next, ...attrs) => {
	const prevAttributes = pick.apply(null, [previous, ...attrs]),
		nextAttributes = pick.apply(null, [next, ...attrs]);

	return !shallowequal(prevAttributes, nextAttributes);
};